/** Check if a value is not empty string `''`. */
export function notEmpty(value) {
    return value !== '';
}
